import { z } from 'zod';

export const PlaceUserListItemSchema = z.object({
  userId: z.uuid(),
  fullName: z.string(),
  email: z.string(),
});

export type PlaceUserListItem = z.infer<typeof PlaceUserListItemSchema>;

export const ListPlaceUsersResponseSchema = z.object({
  items: z.array(PlaceUserListItemSchema),
});

export type ListPlaceUsersResponse = z.infer<typeof ListPlaceUsersResponseSchema>;
